// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { CdkPortal, TemplatePortal } from '@angular/cdk/portal';
import { NgClass, NgStyle } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import {
  OverlayHelper,
  overlayUserConfiguration,
} from '../../../../helpers/_old_helpers/overlayHelperClass';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import { LoadingDropdownComponent } from '../../loading-dropdown/loading-dropdown.component';
import { InputTextComponent } from '../input-text/input-text.component';

@Component({
  selector: 'lbca-select',
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
  imports: [InputTextComponent, CdkPortal, NgClass, NgStyle, LoadingDropdownComponent],
})
export class SelectComponent implements AfterViewInit {
  @ViewChild('mainElement', { static: true }) mainElement!: ElementRef;
  @ViewChild('templateAppend', { static: true }) templateAppend!: TemplatePortal;

  private errorPopup!: ErrorOverlayClass;
  private selectOverlay!: OverlayHelper;

  public hasError = false;
  public autoSort = true;

  public componetHelperIconStyle: any = null;

  private option: Array<any> = [];
  private valUnsorted: any[] = [];
  public optionRestored: any[] = [];
  public excludeItens: any[] = [];
  public optionFiltered: any[] = [];
  public chosed = false;

  public labelValue = '';
  public helperTextValue = '';
  public isRequired = false;
  public isDisabled = false;
  public isLabeled = false;
  public isTabeled = false;
  public isEditable = false;

  public valueSelected: any = null;
  public errorList: any = null;
  private _valueInput: any = null;
  public set valueInput(value: any) {
    this._valueInput = value;
  }
  public get valueInput() {
    return this._valueInput;
  }

  public setInitialValue!: string;
  public loadingAnimation!: boolean;

  @Input() set initialValue(iv: string) {
    this.setInitialValue = iv;
  }
  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input() set removeItens(itens) {
    this.excludeItens = itens;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = !value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set loading(value: boolean) {
    this.loadingAnimation = value;
  }
  @Input() autoSelect = false;
  @Input() autoSelectLen = 1;
  @Input() autoSelectIndexArray = 0;

  @Input('sort')
  set sortItens(order: boolean) {
    if (order !== undefined && order !== null) {
      this.autoSort = order;
      this.option = [...this.optionRestored];
    }
  }

  public keySort = 'label';
  @Input('keySort') set keySortValue(key: string) {
    if (key) {
      this.keySort = key;
    }
  }

  @Input('options')
  set optionsList(val: any) {
    this.optionRestored = val;
    if (!val) return;
    const valSorted = this.autoSort
      ? val.sort((a, b) => String(a[this.keySort]).localeCompare(String(b[this.keySort])))
      : val;

    this.option = [...valSorted];
    this.optionFiltered = [...valSorted];
    this.calcHeightProp();
    this.value = this.valueSelected;
  }
  @Input() set value(value: string) {
    if (value === '' || value === undefined) {
      this.valueInput = '';
    } else {
      this.valueSelected = value;
      const select = this.option.find((opt) => opt.id === this.valueSelected);

      if (select) this.valueInput = select.label;
    }
  }

  @Input('error')
  set err(error: any) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }

  @Output() focusState = new EventEmitter();
  @Output('changeValue') changeEmmiter = new EventEmitter();
  @Output('changeLabelValue') changeLabelEmmiter = new EventEmitter();
  @Output('errorState') setErrorEmmiter = new EventEmitter();

  public bindProperties: any = {
    width: 320,
    height: 240,
  };

  public componetIconStyle = 'svg-icon-angle bg-gray-600 transition duration-400 ease-in-out';

  constructor() {
    const overlay = inject(Overlay);
    const elementRef = inject(ElementRef);

    this.selectOverlay = new OverlayHelper(overlay);

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'end'
    );
  }

  ngAfterViewInit(): void {
    const wid = this.calcWidth();
    const mainElementWid = Math.round(this.mainElement.nativeElement.getBoundingClientRect().width);

    this.bindProperties.width = wid > mainElementWid ? wid : mainElementWid;

    const config: overlayUserConfiguration = {
      positionStrategy: 'flexible',
      scrollStrategy: 'close',
      offsetY: 16,
      connectedTo: this.mainElement,
      flexiblePositionStrategy: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
      ],
    };

    this.selectOverlay.setConfiguration(config);

    this.autoSelectValue();

    if (this.excludeItens)
      this.optionFiltered = this.optionFiltered.filter(
        (limpa) => !this.excludeItens.includes(String(limpa.id))
      );

    setTimeout(() => {
      if (this.setInitialValue) {
        const verify = this.optionFiltered.find(
          (initalValueCheck) => this.setInitialValue === initalValueCheck.id
        );
        if (verify) this.selectOption(null as any, verify);
      }
    }, 300);
  }

  autoSelectValue() {
    if (this.autoSelect) {
      setTimeout(() => {
        try {
          if (this.optionFiltered.length === this.autoSelectLen) {
            this.selectOption(null as any, this.optionFiltered[this.autoSelectIndexArray]);
          }
        } catch (e) {
          console.warn('[autoSelectValue]', e);
        }
      }, 100);
    }
  }

  public selectOption($event: MouseEvent, option: any): void {
    this.chosed = true;
    this.valueInput = option?.label;
    this.valueSelected = option?.id;
    this.changeEmmiter.emit(option?.id);
    this.changeLabelEmmiter.emit(option?.label);
    this.setErrorEmmiter.emit([]);
    this.closeSelectBox();
  }

  public clearSelectedOption() {
    this.chosed = false;
    this.valueInput = '';
    this.valueSelected = '';
    this.setErrorEmmiter.emit([]);
  }

  private calcWidth() {
    const body = document.body,
      html = document.documentElement;

    const maxWindowSize = Math.max(
      body.scrollWidth,
      body.offsetWidth,
      html.clientWidth,
      html.scrollWidth,
      html.offsetWidth
    );

    let maiorLen = 0;
    this.option.forEach((item) => {
      if (item.label.length > maiorLen) maiorLen = item.label.length;
    });
    const calc = maiorLen * 5;

    return calc > maxWindowSize ? maxWindowSize : calc;
  }

  private calcHeightProp(): void {
    const length = this.optionFiltered.length;

    let size = 220;

    if (length >= 5) size = 220;
    else if (length === 1) size = 44;
    else if (length === 0) size = 32;
    else size = length * 44;

    this.bindProperties.height = size;
  }

  public click() {
    const focusedElement = document.activeElement;
    if (focusedElement instanceof HTMLInputElement) {
      this.componetIconStyle =
        'svg-icon-angle bg-primary transition duration-400 ease-in-out rotate-180';
      this.openSelectBox();
    }
  }

  public setFocus(focus: any): void {
    this.focusState.emit(focus);
    if (focus) {
      this.componetIconStyle =
        'svg-icon-angle bg-primary transition duration-400 ease-in-out rotate-180';
      this.openSelectBox();
    } else {
      this.componetIconStyle = 'svg-icon-angle bg-gray-600 transition duration-400 ease-in-out';
      this.closeSelectBox();
      if (!this.chosed) {
        this.componetHelperIconStyle = null as any;
        this.optionFiltered = [...this.option];
        this.calcHeightProp();
      }
    }
  }

  public changeEvent($event) {
    if (!this.chosed) {
      $event.target.value = '';
      this.valueInput = '';
    }
  }

  private openSelectBox(): void {
    this.selectOverlay.show(this.templateAppend);
    this.errorPopup.setFocus(true);
  }

  private closeSelectBox(): void {
    setTimeout(() => {
      this.selectOverlay.close();
      this.errorPopup.setFocus(false);
    }, 150);
  }

  public setErrorControllEmmiter($event) {
    this.setErrorEmmiter.emit($event);
  }

  public inputKeyUpEvent($event) {
    const value = $event.target.value;
    this.chosed = false;
    if (value)
      this.componetHelperIconStyle =
        'svg-icon-search bg-gray-600 transition duration-400 ease-in-out';
    else this.componetHelperIconStyle = null as any;
    if (value !== '') {
      this.optionFiltered = this.option.filter((item) => {
        return RegExp(value, 'ig').test(item.label);
      });
      this.calcHeightProp();
    } else {
      // copiar todas as opções quando apaga o input
      this.optionFiltered = [...this.option];
      this.calcHeightProp();
    }
  }
}
